export default __webpack_public_path__ + "static/media/3.4cca5d20.mp4";